import { makeStyles } from "@material-ui/core/styles"

export const useTopBarStyles = makeStyles((theme) => ({
    appBar: {
        transition: theme.transitions.create(["width", "margin"], {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp,
        }),
        zIndex: theme.zIndex.drawer + 1,
        marginLeft: theme.spacing(7),
        width: `calc(100% - ${theme.spacing(9)}px)`,
        backgroundColor: "rgb(250,250,250)",
        boxShadow: "none",
        left: 0,
        // [theme.breakpoints.up('md')]: {
            minWidth: 1200,
        // },
    },
    appBarShift: {
        marginLeft: theme.constant.drawerWidth,
        transition: theme.transitions.create(["width", "margin"], {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.sharp,
        }),
        width: `calc(100% - ${theme.constant.drawerWidth}px)`,
    },
    link: {
        margin: theme.spacing(1, 1.5),
    },
    FabIcon: {
        backgroundColor: "white",
        color: "#999",
    },
    menuButtonHidden: {
        display: "none",
    },
    title: {
        flexGrow: 1,
        color: "rgb(85,85,85)",
        marginLeft: theme.spacing(2),
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end",
        padding: "0 8px",
        ...theme.mixins.toolbar,
    },
}))
